<footer>
  <div
    class="green-border"
    [style.background-color]="env['colors']['secondary']"
  ></div>
  <div
    class="copyright-div"
    [style.background-color]="env['colors']['primary']"
  >
    {{ copyright }}
  </div>
</footer>
